<template>
    <LayoutBlock
    :tutorial_dialog="tutorial_dialog"
    v-on:closeDialog="handleCloseDialog"
    >
    <div class="d-flex">
        <v-row no-gutters>
            <v-col cols="6">
                <v-radio-group class="no_space_vertical" v-model="measures.hi_res" label="Alta risoluzione"  :disabled="preview">
                <v-radio label="Attivo" value="on"></v-radio>
                <v-radio label="Disattivo" value="off"></v-radio>
                </v-radio-group>
            </v-col>
            <v-col cols="6" v-if="data.block.name == 'pretest'" >
                <v-radio-group v-model="radioMPE" :disabled="preview">
                    <v-radio label="MPE in alta risoluzione" value="mpeNormal" />
                    <v-radio label="MPE con arrotondamento" value="mpeRounded"/>
                </v-radio-group>
            </v-col>
        </v-row>
    </div>
    <v-expansion-panels focusable>
        <v-expansion-panel v-for="(item, index) in measures.items" :key="index" v-model="panels[index]">
            <v-expansion-panel-header color="expansion">
                <div class="d-flex" >
                    <v-btn fab text small class="mx-3" color="action" @click.stop="deleteItem(item)" v-if="measures.items.length > data.block.conf.min_readings"><v-icon>delete</v-icon></v-btn>
                    <div class="d-flex" v-if="item.data">
                        {{ item.index +1 }}: {{item.data.nom | formatNumber}}{{ data.instrument_data.uom }}
                        <ResultBlock :result="item.data.result" class="pl-6"/>
                    </div>
                    <div class="d-flex" v-else>
                        {{item.index +1}}
                    </div>
                </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <tabella
                v-if="!isPretest && !isTare"
                :stub="item"
                :headers="data.block.conf.headers"
                :instrument="data.instrument_data"
                :primaries="primariesFilter"
                :mpeIntervals="computedMPE"
                :stdevIntervals="computedStdev"
                :radioMPE="radioMPE"
                :isPretest="isPretest"
                :isTare="isTare"
                :preview="preview"
                :calculateNum="true"
                :resolution="measures.hi_res"
                :prec="precision"
                :high_prec="high_precision"
                :op_types="data.block.op_types"
                @update="handleUpdate"
                />
                <taraTabella
                v-if="isTare"
                :stub="item"
                :headers="data.block.conf.headers"
                :instrument="data.instrument_data"
                :primaries="primariesFilter"
                :mpeIntervals="computedMPE"
                :stdevIntervals="computedStdev"
                :radioMPE="radioMPE"
                :isPretest="isPretest"
                :isTare="isTare"
                :preview="preview"
                :calculateNum="true"
                :resolution="measures.hi_res"
                :prec="precision"
                :high_prec="high_precision"
                :op_types="data.block.op_types"
                @update="handleUpdate"
                />
                <pretestTabella
                v-if="isPretest"
                :stub="item"
                :headers="data.block.conf.headers"
                :instrument="data.instrument_data"
                :mpeIntervals="computedMPE"
                :radioMPE="radioMPE"
                :isPretest="isPretest"
                :isTare="isTare"
                :preview="preview"
                :primaries="primariesFilter"
                :calculateNum="true"
                :resolution="measures.hi_res"
                :prec="precision"
                :high_prec="high_precision"
                :op_types="data.block.op_types"
                @update="handleUpdate">
                </pretestTabella>
                
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
    </LayoutBlock>
</template>
<script>
import LayoutBlock from "../../../components/utils/LayoutBlock"
import ResultBlock from "../../../components/utils/ResultBlock"
import {AwiLeg} from "../../../utils/awiLeg"
import {stdev_values} from "../../../utils/common"
import tabella from "../../../components/utils/awi_table"
import pretestTabella from "../../../components/utils/awi_table_y"
import taraTabella from "../../../components/utils/awi_table_tare"
export default {
    components: {LayoutBlock, ResultBlock, tabella, pretestTabella, taraTabella},
    mixins: [AwiLeg],
    data() {
        return {
            tutorial_dialog: {
                dialog: false,
                message: "Tutorial per la linearità AWI X"
            },
          
        }
    },
    computed: {
        computedMPE(){
            let temp = []
            if(this.data.selected_mode === "installation"){
                temp = [0.5,1,1.5]
            }
            else {
                temp = [1,2,3]
            }
            if(this.radioMPE == "mpeRounded"){
                return temp.map(x => x + 0.5)
            } else {
                return temp
            }
        },
        computedStdev(){
            if(this.data.selected_mode === "installation"){
                return stdev_values.in_installation
            } else {
                return stdev_values.in_service
            }
        }
    }
}
</script>